import IParamServices from "../IParamServices";
import BaseService from "../base/BaseService";
import { IContract } from "@/core/model/sys/IContract";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import { IPagedParameters, IPagedResult } from "@/core/model/sys/IPagedParameters";
import { IEdoCta } from "@/core/model/sys/IEdoCta";
import { eTypeEdoCta } from "@/core/model/GloblasEnum";
import { ICustomer } from "@/core/model/sys/ICustomer";

export default class ContractService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public NewContract() : IContract
  {
    return {
      Gid	: this.NewId,
      Alias:'',
      Code:'',
      UniqueNumber:'',
      Customer:null,
      Address:null,
      QoutaType:null,
      //Quota: 0,
      StartDate:new Date(),
      ContractDay:1,
      Comments:'',
      ModifiedByEmployee:null,
      ModifiedTime: new Date(),
      Active:true,
      IsNew:true
    };
  }
  public async CustomerContracts(customer:ICustomer):Promise<IContract[]>
  {      
    const result = Array<IContract>();
    const response:IServiceResponse = await this.Get('IndexContract/CustomerContracts/'+customer.Gid,null,null,null,true,false,null); 
    if(response && response.Response)
    {            
      for (const element of response.Response)
      {       
        result.push({...element});  
      }
    }                
    return result;
  }
  public async GetContractById(id:any):Promise<IContract|null>
  {      
    const response:IServiceResponse = await this.Get('IndexContract/GetContractById/'+id,null,null,null,true,false,null); 
    if(response)
    {
      return response.Response;
    }                
    return null;
  }
  public async ContractPaged(paged:IPagedParameters,filter?:string,tipo?:number):Promise<IPagedResult<IContract>>
  {
    const result: IPagedResult<IContract> = {
      Paged:null,
      Result:[]
    }    
    const filters = {
      Page: paged.Page,      
      Search: filter
    }  
    const response:IServiceResponse = await this.Post('IndexContract/ContractPaged',tipo===2? paged: filters,null,null,null,true,false,null); 
    if(response)
    {
      result.Paged = response.Paged;
      result.Result = response.Response? response.Response:[];
    }                
    return result;
  }
  public async SaveContract(contractData:IContract) : Promise<IContract>
  {        
    let response:IServiceResponse|null = null;
    const contract = {...contractData};
    //customer.ModifiedByEmployee = null;
    response = await this.Post('IndexContract/SaveContract',contract,null,null,null,true,false,null);
    if(response && response.Response)
    {
      if(response.Response.Error)
      {
        contract.Active = false;
        contract.Comments = response.Response.Response;  
      }
      else
      {
        contract.Code = response.Response.ContractDto.Code;
        contract.Active = true;
        contract.Comments = '';  
      }
    }
    return contract;
  }
  public async ContractEdoCta(contract:IContract,ini?:Date,fin?:Date):Promise<IEdoCta|null>
  {    
    const params = {
      Id:contract.Gid,
      Ini:ini,
      Fin:fin,
    }
    const response:IServiceResponse = await this.Post(`IndexEdoCta/ContractEdoCta`,params ,null,null,null,true,false,null); 
    if(response && response.Response)
    {
      const edo:IEdoCta = {...response.Response};
      edo.Type = eTypeEdoCta.Contract;
      edo.Contract = contract;
      return edo;
    } 
    else
      return null;
  }  
  public async ContractEdoCtaExcel(contract:IContract,ini?:Date,fin?:Date):Promise<IServiceResponse>
  {        
    const params = {
      Id:contract.Gid,
      Ini:ini,
      Fin:fin,
    }
    const response:IServiceResponse = await this.Post(`IndexEdoCta/ContractEdoCtaExcel2`,params,null,null,null,true,undefined,'arraybuffer' );
    return response;
  }
  public async EdoCtaCustomer(customer:ICustomer,ini?:Date,fin?:Date,Contract?:IContract):Promise<IEdoCta|null>
    {    
      const params = {
        Id:customer.Gid,
        ContractId:Contract?Contract.Gid:null,
        Ini:ini,
        Fin:fin,
      }
      const response:IServiceResponse = await this.Post(`IndexEdoCta/EdoCtaCustomer`,params ,null,null,null,true,false,null); 
      if(response && response.Response)
      {
        const edo:IEdoCta = {...response.Response};
        edo.Type = eTypeEdoCta.Customer;
        edo.Contract = null;
        edo.Customer = customer;
        return edo;
      } 
      else
        return null;
    }
  public async EdoCtaCustomerExcel(customer:ICustomer,ini?:Date,fin?:Date,Contract?:IContract):Promise<IServiceResponse>
  {
    const params = {
      Id:customer.Gid,
      ContractId:Contract?Contract.Gid:null,
      Ini:ini,
      Fin:fin,
    }
    const response:IServiceResponse = await this.Post(`IndexEdoCta/EdoCtaCustomerExcel`,params,null,null,null,true,undefined,'arraybuffer' );
    return response;
  }
  public async UpdateComments(contract:any):Promise<IContract>
  {    
    const update ={
      Gid:contract.Gid,
      Comments:contract.Comments
    }
    await this.Post(`IndexContract/UpdateComments`,update ,null,null,null,true,false,null); 
    return contract;
  }  
}